import i18n from 'services/i18n/i18n';

export const priceOptions = () => {
  return [
    { label: i18n.t('select.default_price.wholesale'), value: 'opt' },
    { label: i18n.t('select.default_price.mark_up'), value: 'extra' },
    { label: i18n.t('select.default_price.retail'), value: 'retail' },
  ];
};
